/**
 * Reports uncaught client errors to the server (which logs them) so crashes are
 * visible instead of silent. Fire-and-forget, capped per page load, and wrapped
 * so reporting can never itself break the app.
 */

let sent = 0;
const MAX_PER_LOAD = 10; // avoid flooding / report loops

export function reportClientError(
  error: unknown,
  source: string,
  extra?: { componentStack?: string }
): void {
  if (sent >= MAX_PER_LOAD) return;
  sent += 1;

  try {
    const message = error instanceof Error ? error.message : String(error);
    const stack = error instanceof Error ? error.stack : undefined;

    void fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      keepalive: true, // still sends if the page is unloading
      body: JSON.stringify({
        message,
        stack,
        componentStack: extra?.componentStack,
        source,
        url: window.location.href,
      }),
    }).catch(() => {
      /* reporting must never throw */
    });
  } catch {
    /* never let reporting break the app */
  }
}
